// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"cc","newscontentBox":"cc"};